// This module intentionally has no dependencies so it can be imported from
// non-browser tooling (e.g. NES codegen scripts).
//
// When adding a new type, run: cd services/notebook-evaluation && yarn sync:evaluate-contract
export enum CollectibleLegacyTableType {
  LEGACY_REGISTRATION_TABLE = 'LEGACY_REGISTRATION_TABLE',
  LEGACY_RESULT_TABLE = 'LEGACY_RESULT_TABLE',
  LEGACY_TRANSFER_TABLE = 'LEGACY_TRANSFER_TABLE',
}
